import { render, staticRenderFns } from "./custom_select.vue?vue&type=template&id=bff67d7e&scoped=true&"
import script from "./custom_select.vue?vue&type=script&lang=js&"
export * from "./custom_select.vue?vue&type=script&lang=js&"
import style0 from "./custom_select.vue?vue&type=style&index=0&id=bff67d7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff67d7e",
  null
  
)

export default component.exports